import { Component,  Input } from '@angular/core';
import { SliderImage } from 'globals/store/publish.data';
import publicHelpers from '../../helpers/public-helpers';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'slider-image',
    template: `
<img [src]="sliderImage.imageUrl || 'assets/placeholder_event_list.png'" [ngClass]="{ hasLink: !!sliderImage.linkUrl }" (click)="sliderImage.linkUrl ? helpers.openInNewTab(sliderImage.linkUrl) : null" />
`,
    styles: [`
  :host { background: var(--contentbg); width: 360px; height: 300px; display: block; }
  img { width: 360px; height: 300px; }
  img.hasLink { cursor: pointer; }
`],
    standalone: true,
    imports: [CommonModule]
})
export class SliderImageComponent {
  @Input() sliderImage: SliderImage
  helpers = publicHelpers
}